import { View } from 'react-native'
import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface ModalActionsProps {
  children: ReactNode
  className?: string
}

export function ModalActions({ children, className }: ModalActionsProps) {
  return (
    <View className={twMerge('z-0 flex-col gap-3 lg:flex-row', className)}>
      {children}
    </View>
  )
}